import React from "react";
import YouTube from "react-youtube";

import "./YoutubePopup.css";

const YoutubePopup: React.FC<{
  videoId: string;
  onButtonClick: (show: boolean) => void;
}> = ({ videoId, onButtonClick }) => {
  const handleClick = (show: boolean) => {
    if (onButtonClick) {
      onButtonClick(show);
    }
  };

  const opts = {
    playerVars: {
      autoplay: 1,
    },
  };

  return (
    <div className="youtube-popup-container" onClick={() => handleClick(false)}>
      <div
        className="youtube-popup-content"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="popup-header">
          <h5> </h5>
          <button
            className="youtube-popup-close-button"
            onClick={() => handleClick(false)}
          ></button>
        </div>
        <div className="youtube-video-wrapper">
          <YouTube videoId={videoId} opts={opts} />
        </div>
      </div>
    </div>
  );
};

export default YoutubePopup;
